import { MenuItem } from '../model/menu/menu-item';
import { StandardAction } from '../tool/action/standard-action';

export class MenuItemBuilder {
  private menuItems: MenuItem = new MenuItem('', '', '');
  constructor(id: string, label: string, icon: string, route?: string) {
    this.menuItems.id = id;
    this.menuItems.label = label;
    this.menuItems.icon = icon;
    if (route) {
      this.menuItems.route = route;
    }
  }

  public setRoute(route: string): MenuItemBuilder {
    this.menuItems.route = route;
    return this;
  }

  public setDraggable(draggable: boolean): MenuItemBuilder {
    this.menuItems.draggable = draggable;
    return this;
  }

  public disable(): MenuItemBuilder {
    this.menuItems.disabled = true;
    return this;
  }

  public enable(): MenuItemBuilder {
    this.menuItems.disabled = false;
    return this;
  }

  public setSubmenus(submenus: MenuItem[]): MenuItemBuilder {
    this.menuItems.submenus = submenus;
    return this;
  }

  public addSubmenu(submenu: MenuItem): MenuItemBuilder {
    this.menuItems.submenus.push(submenu);
    return this;
  }

  public removeSubmenu(id: string): MenuItemBuilder {
    this.menuItems.submenus = this.menuItems.submenus.filter(
      (item) => item.id !== id,
    );
    return this;
  }

  public setActions(actions: StandardAction[]): MenuItemBuilder {
    this.menuItems.actions = actions;
    return this;
  }

  public addAction(action: StandardAction): MenuItemBuilder {
    this.menuItems.actions.push(action);
    return this;
  }

  public removeAction(name: string): MenuItemBuilder {
    this.menuItems.actions = this.menuItems.actions.filter(
      (item) => item.name !== name,
    );
    return this;
  }

  public setPatternMatcher(patternMatcher: RegExp): MenuItemBuilder {
    this.menuItems.patternMatcher = patternMatcher;
    return this;
  }

  public build(): MenuItem {
    return this.menuItems;
  }
}
